import APIService from "./apiService";

class AuthService extends APIService {
  constructor() {
    super(process.env.REACT_APP_API_BASEURL)
  }

  async adminLogin(data) {
    const { email, password, role } = data
    return this.post("/auth/signin", { email, password })
      .then((response) => {
        if(response?.data?.status >= 200 && response?.data?.status <= 399) {
          this.setAccessToken(response?.data?.data?.token);
          localStorage.setItem('id', response?.data?.data?.id)
          localStorage.setItem('name', response?.data?.data?.userName)
          localStorage.setItem('email', response?.data?.data?.email)
          localStorage.setItem('role', role)
          return response?.data;
        }
        else {
          throw new Error('Incorrect email or password.')
        }
      })
      .catch((error) => {
        throw error.message
        // throw error?.response?.data;
      });
  }

  async consultantLogin(data) {
    const { email, password, role } = data
    return this.post("/consultant/signin", { email, password })
      .then((response) => {
        if(response?.data?.status >= 200 && response?.data?.status <= 399) {
          this.setAccessToken(response?.data?.data?.token);
          localStorage.setItem('id', response?.data?.data?.id)
          localStorage.setItem('name', response?.data?.data?.userName)
          localStorage.setItem('email', response?.data?.data?.email)
          localStorage.setItem('role', role)
          return response?.data;
        }
        else {
          throw new Error('Incorrect email or password.')
        }
      })
      .catch((error) => {
        throw error.message
        // throw error?.response?.data;
      });
  }

  async adminSignUp(data) {
    return this.post("/auth", data)
      .then((response) => {
        // this.setAccessToken(response?.data?.access_token);
        // this.setRefreshToken(response?.data?.refresh_token);
        return response?.data;
      })
      .catch((error) => {
        throw error?.response?.data;
      });
  }

  isAlreadyLogin() {
    return !!this.getAccessToken()
  }

  getUserInfo() {
    const id = localStorage.getItem('id')
    const name = localStorage.getItem('name')
    const email = localStorage.getItem('email')
    const role = localStorage.getItem('role')

    if(id !== '' && name !== '' && email !== '' && role !== '') {
      return {
        id, name, email, role
      }
    }
    else {
      return null
    }
  }

  async logout() {
    this.purgeAccessToken()
    localStorage.removeItem('id')
    localStorage.removeItem('name')
    localStorage.removeItem('email')
    localStorage.removeItem('role')
    localStorage.removeItem('ReadinessIndexType')
    localStorage.removeItem('SelectedFilter')
  }
}

const authService = new AuthService()
export default authService